import React, { useState, useEffect } from "react";
import moment from "moment";
import { logout } from "../modules/auth/Auth.ducks";
import avatarUrl from "../styles/img/user-avatar.jpg";
import srcLogokiuono from "../../src/styles/img/logo-kiuono.svg";
import srcIconNotif from "../../src/styles/img/icon-notif.svg";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import _ from "lodash";
import ModalNotificationsSidebar from "./ModalNotificationsSidebar";
import { Service } from "../modules/service/service";
import { API } from "../const";
import { NotificationsDelete } from "../modules/kids/kids-list/fiche-enfant/les-tabs-ducks/Journee.ducks";

const IconLogoKiuono = () => (
  <object
    data={srcLogokiuono}
    style={{
      pointerEvents: "none",
      width: "160px",
      height: "63.68px",
      cursor: "pointer",
    }}
    type="image/svg+xml"
    className="img-fluid"
  />
);
//This is a dummy comment
const IconNotif = () => (
  <object
    data={srcIconNotif}
    type="image/svg+xml"
    style={{
      verticalAlign: "middle",
      borderStyle: "none",
      pointerEvents: "none",
      width: "30px",
      height: "30px",
      cursor: "pointer",
    }}
    className="img-fluid"
  />
);
let interval = null;
const CardHeaderComponent = (props) => {
  const [seconds, setSeconds] = useState(0);
  const [show, setDrop] = useState(false);
  const [modalNotificationSideBar, setOpen] = useState(false);

  const [listNotifications, setListNotifications] = useState([
    props.listNotifications,
  ]);

  useEffect(() => {
    setListNotifications(props.listNotifications);
    interval = setInterval(() => {
      getNotifications();
    }, 900000);
    return function cleanup() {
      clearInterval(interval);
    };
  }, [props.listNotifications]);
  function getNotifications() {
    let tok = localStorage.getItem("token");
    const response = Service.get(`${API}api/creche/notifications`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      let sortedNotificationsSidebar = _.isEmpty(res.data.notifications)
        ? []
        : res.data.notifications.sort((a, b) =>
            moment(b.dateTime).diff(a.dateTime)
          );
      setListNotifications(sortedNotificationsSidebar);
    });
  }
  function handlClicCompte() {
    setDrop(false);
  }
  function handlClic() {
    props.logout();
  }
  function onOpenModaleNotificationsSidebar() {
    if (!modalNotificationSideBar && !_.isEmpty(listNotifications)) {
      setOpen(!modalNotificationSideBar);
    } else if (!_.isEmpty(listNotifications)) {
      let idsNotificationSideBar = [];
      idsNotificationSideBar =
        !_.isEmpty(listNotifications) &&
        listNotifications.map((element) => element.id);
      onCloseModaleNotificationsSidebar(idsNotificationSideBar);
    }
  }

  function onCloseModaleNotificationsSidebar(ids) {
    props.NotificationsDelete(localStorage.getItem("token"), ids);
    setListNotifications([]);
    setOpen(false);
  }

  let lienPhoto = !_.isEmpty(props.compteData.data)
    ? props.compteData.data.urlPhoto
    : "";
  var divStyle = (lienPhoto) => ({
    backgroundImage: "url(" + lienPhoto + ")",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    overflow: "hidden",
  });
  return (
    <nav className="top-nav d-flex align-items-center justify-content-between">
      <div className="left">
        <Link to="/" className="logo-main">
          <IconLogoKiuono className="img-fluid" />
        </Link>
      </div>
      <div className="right d-flex align-items-center justify-content-end">
        <p className="date-day mr-3">{`${moment().format(
          "ddd D MMMM HH"
        )}h${moment().format("mm")}`}</p>
        <form className="searchForm mr-3">
          <input
            type="text"
            className="form-control"
            placeholder="Rechercher"
          />
        </form>
        <a
          style={
            props.listNotifications.length === 0
              ? { pointerEvents: "none" }
              : {}
          }
          className="notifications mr-3"
          onClick={onOpenModaleNotificationsSidebar}
        >
          <IconNotif className="img-fluid" />
          <span className="nb-notifs d-flex align-items-center justify-content-center">
            {!_.isEmpty(listNotifications) ? listNotifications.length : 0}
          </span>
        </a>
        <div
          className="avatar-fiche"
          style={divStyle(lienPhoto)}
          onClick={() => setDrop(!show)}
        />
        <div className="dropdown-account" style={{ display: "block" }}>
          {show ? (
            <ul>
              <li>
                <Link to="/compte" onClick={() => handlClicCompte()}>
                  Mon compte
                </Link>
              </li>
              <li>
                <a href="#" onClick={() => handlClic()}>
                  Déconnexion
                </a>
              </li>
            </ul>
          ) : (
            ""
          )}
        </div>
      </div>

      {modalNotificationSideBar ? (
        <ModalNotificationsSidebar
          onOpenModaleNotificationsSidebar={onOpenModaleNotificationsSidebar}
          onCloseModaleNotificationsSidebar={onCloseModaleNotificationsSidebar}
          listNotifications={listNotifications}
        />
      ) : (
        ""
      )}
    </nav>
  );
};

export default connect(null, { logout, NotificationsDelete })(
  CardHeaderComponent
);
